import * as Redux from 'redux';
import uniqWith = require('lodash/uniqWith'); // tslint:disable-line: no-require-imports
import {
	RENEW_AUTHENTICATION__ACTIONTYPES,
	GLOBAL__ACTIONSCOPE,
} from '../constants/global';
import {AuthenticationError} from '../../errors';

export function createGatedReducer<T>(
	reducer: Redux.Reducer<T>,
	gate: ActionScope,
): Redux.Reducer<T> {
	return (state: T, action: Action) => {
		if (action.scope === gate || action.scope === GLOBAL__ACTIONSCOPE) {
			return reducer(state, action);
		} else {
			return reducer(state, {type: 'OUT_OF_SCOPE_ACTION'});
		}
	};
}

export function shouldLogOutOnFailure(action: AsyncFailureAction): boolean {
	return action.failureReference === RENEW_AUTHENTICATION__ACTIONTYPES.FAILURE
		|| action.asyncFailureData.error instanceof AuthenticationError;
}

export function limitAuthenticationErrorsFlashed(errors: Error[]) {
	return uniqWith(errors, (e1: Error, e2: Error) => {
		if (e1 instanceof AuthenticationError && e2 instanceof AuthenticationError) {
			return e1.name === e2.name;
		} else {
			return false;
		}
	});
}

export function clearAuthenticationErrors(errors: Error[]) {
	return errors.filter(e => !(e instanceof AuthenticationError));
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/reducers/util.ts